
const defaultState = {
	preference: [],
	isLoading : false,
	error: null, 
	success : false
}
export default function userPreference(state = defaultState, action) {
	switch (action.type) {

		case "FETCH_PREFERENCE_SUCCESS" :
            console.log('res.preference.data',action)
			return {...state, preference : action.data};
		
		case "FETCH_PREFERENCE_ERROR":
			return {...state, error : action.data}
		
		case "IS_LOADING" :
			return {...state, isLoading: action.data}
		default:
			return state;
	}
}





// WEBPACK FOOTER //
// ./src/reducers/userpreference.js